module.exports = __webpack_public_path__ + "static/media/home.7fabd933.svg";